/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Thisactioncannotbeundone4Inputs */

const en_thisactioncannotbeundone4 = /** @type {(inputs: Thisactioncannotbeundone4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This action cannot be undone.`)
};

const de_thisactioncannotbeundone4 = /** @type {(inputs: Thisactioncannotbeundone4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Aktion kann nicht rückgängig gemacht werden.`)
};

/**
* | output |
* | --- |
* | "This action cannot be undone." |
*
* @param {Thisactioncannotbeundone4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const thisactioncannotbeundone4 = /** @type {((inputs?: Thisactioncannotbeundone4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Thisactioncannotbeundone4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_thisactioncannotbeundone4(inputs)
	return de_thisactioncannotbeundone4(inputs)
});
export { thisactioncannotbeundone4 as "thisActionCannotBeUndone" }